import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import { DataGrid, gridClasses } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { EDIT_TERM_TEMPLATE_MUTATION } from "../../graphQL/term_template_qry";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function TemplateInfoInputDialog({ closeDialog, termTemplateInfo }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    templateName: "",
    noOfSeats: "",
  });
  const [templateName, setTemplateName] = useState(termTemplateInfo.name);
  const [description, setDescription] = useState(termTemplateInfo.description);
  const [noOfSeats, setNoOfSeats] = useState(termTemplateInfo.noOfSeats);
  const [alertMsg, setAlertMsg] = useState([]);
  const [updatedTermTemplateInfo, setUpdatedTermTemplateInfo] =
    useState(termTemplateInfo);
  const clientId = localStorage.getItem("clientId");

  const [editTermTemplate] = useMutation(EDIT_TERM_TEMPLATE_MUTATION, {
    awaitRefetchQueries: true,
  });

  console.log("termTemplateInfo", termTemplateInfo);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog(updatedTermTemplateInfo);
  };

  const handleTemplateNameChange = event => {
    if (event.target.value.trim() === "")
      setErrorMsg({ templateName: "Template Name cannot be blank." });
    else setErrorMsg({ templateName: "" });
    setTemplateName(event.target.value);
  };
  const handleDescriptionFieldChange = event => {
    setDescription(event.target.value);
  };
  const handleNoOfSeatsChange = event => {
    if (parseInt(event.target.value) < 1) {
      setErrorMsg({ noOfSeats: "Enter an integer greater than zero." });
    } else if (event.target.value.toString().trim() === "") {
      setErrorMsg({ noOfSeats: "No of Seats cannot be blank." });
    } else {
      setErrorMsg({ noOfSeats: "" });
      setNoOfSeats(parseInt(event.target.value));
    }
  };

  const handleSave = async () => {
    if (templateName.trim() === "") {
      setErrorMsg({ templateName: "Template Name cannot be blank." });
    } else if (noOfSeats < 1) {
      setErrorMsg({ noOfSeats: "Enter an integer greater than zero." });
    } else if (!noOfSeats) {
      setErrorMsg({ noOfSeats: "No of Seats cannot be blank." });
    } else {
      const { data, error } = await editTermTemplate({
        variables: {
          name: templateName,
          description: description,
          clientId: parseInt(clientId),
          noOfSeats: parseInt(noOfSeats),
          termTemplateId: parseInt(termTemplateInfo.termTemplateId),
        },
      });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (data && data.editTermTemplate) {
        setUpdatedTermTemplateInfo(data.editTermTemplate.termTemplate);
        handleClose();
      }
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "400px",
              maxHeight: "485px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Term Template Info
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box
              pt={1}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                color: "black",
              }}
            >
              <Typography variant="h2" style={{ paddingRight: 10 }}>
                {" "}
                Template ID:
              </Typography>{" "}
              {termTemplateInfo.termTemplateId}
            </Box>

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              label="Template Name"
              margin="normal"
              name="templateName"
              variant="outlined"
              id="templateName"
              defaultValue={templateName}
              onChange={handleTemplateNameChange}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.templateName}
              </FormHelperText>
            )}
            
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Description"
              margin="normal"
              name="description"
              variant="outlined"
              id="description"
              value={description}
              onChange={handleDescriptionFieldChange}
              inputProps={{
                maxLength: 250,
              }}
            />

            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              label="No of Seats"
              margin="normal"
              name="noOfSeats"
              type="number"
              variant="outlined"
              id="noOfSeats"
              defaultValue={noOfSeats}
              onChange={handleNoOfSeatsChange}
              InputProps={{
                inputProps: { min: 1, pattern: "^[1-9][0-9]?$", max: 99 },
              }}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.noOfSeats}
              </FormHelperText>
            )}
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
